import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LINK_PATH } from '../../../../constant';
import { useDropdownKeyboardNavigation } from '../../../../components/Custom_Hooks/useDropdownKeyboardNavigation';
import NavigationList from '../../../../components/NavigationList/NavigationList';
import useKeyboardNavigation from '../../../../components/Custom_Hooks/useKeyboardNavigation';

const AnalysisVerification =()=> {
    
    const navigate = useNavigate();
    const location = useLocation();

    const keyMap = {
        'd': '',
        'v': '',
    };
    useKeyboardNavigation(keyMap);
    const data = [
        { to: '', text: 'Data Analysis' },
        { to: '', text: 'Voucher Verification' },
        { to: '', text: 'Quit' },
    ];
    const { selectedItemIndex, setSelectedItemIndex } = useDropdownKeyboardNavigation({
        items: data,
        state: true,
        onItemSelect: (item) => {
            if (['/ledgerbook', '/current_date', '/period'].includes(location.pathname)) {
                return;
            }
            navigate(item.to)
        },

    });
    return (
        <NavigationList
            data={data}
            selectedItemIndex={selectedItemIndex}
            setSelectedItemIndex={setSelectedItemIndex}
            title='Analysis & Verification'
            first_heading=''
        />
    )
}

export default React.memo(AnalysisVerification);
